function addButtonsEevents(root = document){
  const forms = root.querySelectorAll('[data-type="add-to-cart-form"].costum-buy-buttons-card__form');
  forms.forEach(form => {
    if (form.dataset.buttonsInitialized === 'true') return;
    form.dataset.buttonsInitialized = 'true';

    const quantityInputs = form.querySelectorAll('.custom-product-card__variant input');
    quantityInputs.forEach(input => {
      input.addEventListener('change', (event) => {
        let pack = event.target.dataset.packName;
        let varianTitle = event.target.dataset.variantTile;
        let quantity = event.target.dataset.quantity;
        let price = event.target.dataset.price;
        let variantId = event.target.dataset.variantId;
        
        // Remover clase active de todos los botones
        quantityInputs.forEach(btn => {
          btn.checked = false;
        });
        
        event.currentTarget.checked = true;
        
        let labelPrice =  form.querySelector('.-price');
        let propSizeInput = form.querySelector('.custom-prop-size');
        let propCaseInput = form.querySelector('.custom-prop-case');
        let propPriceInput = form.querySelector('.custom-prop-price');
        let propQuantityInput = form.querySelector('.custom-prop-quantity');
        let variantInput = form.querySelector('.product-variant-id');
        let bisTriggers = form.querySelectorAll('.klaviyo-bis-trigger, .plp-bis-trigger');

        propSizeInput.value = pack + " " + varianTitle;
        let is_Pack = pack == '6-pack' ? false : true; // false active the inputs for six pack 
        labelPrice.textContent = price;
        
        propCaseInput.disabled = is_Pack;
        propPriceInput.disabled = is_Pack;
        propQuantityInput.value = quantity;

        if (variantInput && variantId) {
          variantInput.value = variantId;
        }

        if (variantId) {
          bisTriggers.forEach((trigger) => {
            trigger.dataset.variantId = variantId;
            trigger.setAttribute('data-variant-id', variantId);
            const productUrl = trigger.dataset.productUrl || '';
            if (productUrl) {
              const cleanUrl = productUrl.split('?')[0];
              trigger.setAttribute('href', `${cleanUrl}?variant=${variantId}`);
            }
          });
        }
      }); 
    });
  });
}  
